export default "__VITE_ASSET__D_T8n4VN__"